import api from "./apiSmartLogistics";

export default {
  GetCustomers() {
    return api.get("Customers/GetCustomers");
  },

  GetCustomer(id) {
    return api.get("Customers/GetCustomer/" + id);
  },

  AddCustomer(customer) {
    return api.post("Customers", customer);
  },

  UpdateCustomer(customer) {
    return api.put("Customers", customer);
  }
};
